<template>
  <div class="bg-gradient-to-b from-slate-700 to-slate-900 p-4 md:p-8">
    <!-- Hero Section -->
    <div class="max-w-4xl mx-auto mb-16">
      <div class="text-center">
        <h1 class="text-4xl md:text-5xl font-bold text-white mb-6">
          Start Your Research Journey
          <span class="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">For Free</span>
        </h1>
        <p class="text-xl text-gray-300 mb-8">Get instant access to AI-powered research paper analysis - no credit card required</p>
      </div>

      <!-- Sign In Button -->
      <div class="flex justify-center mb-16">
        <button 
          @click="handleGoogleSignIn"
          class="flex items-center px-8 py-4 bg-white rounded-lg font-semibold text-gray-800 hover:shadow-lg transition-all duration-200"
        >
          <img src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" alt="Google" class="w-6 h-6 mr-3" />
          Start Free with Google
        </button>
      </div>

      <!-- Plans Section -->
      <div class="grid md:grid-cols-2 gap-8">
        <!-- Free Plan -->
        <div class="bg-white/10 rounded-2xl p-8 backdrop-blur-sm border border-purple-500/20">
          <div class="text-center mb-8">
            <h2 class="text-2xl font-bold text-white mb-2">Free Plan</h2>
            <div class="text-3xl font-bold text-white mb-2">$0</div>
            <p class="text-gray-300">Start analyzing papers today</p>
          </div>

          <div class="space-y-4 mb-8">
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Upload and analyze research papers</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>AI-powered summaries</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Basic study tools</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>5 papers per month</span>
            </div>
          </div>

          <div class="text-center">
            <button 
              @click="handleGoogleSignIn"
              class="w-full px-8 py-4 bg-white text-gray-800 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-200"
            >
              Get Started
            </button>
          </div>
        </div>

        <!-- Premium Plan (Coming Soon) -->
        <div class="bg-gradient-to-br from-purple-900/50 to-slate-800/50 rounded-2xl p-8 border border-purple-500/20 relative">
          <div class="absolute -top-4 left-1/2 transform -translate-x-1/2">
            <span class="bg-purple-500 text-white px-4 py-1 rounded-full text-sm">Coming Soon</span>
          </div>
          
          <div class="text-center mb-8">
            <h2 class="text-2xl font-bold text-white mb-2">Premium Plan</h2>
            <div class="text-3xl font-bold text-white mb-2">$9.99<span class="text-lg">/month</span></div>
            <p class="text-gray-300">Enhanced research experience</p>
          </div>

          <div class="space-y-4 mb-8">
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Everything in Free plan</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Unlimited paper analysis</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Advanced AI interactions</span>
            </div>
            <div class="flex items-center text-gray-300">
              <i class="pi pi-check text-green-400 mr-3"></i>
              <span>Priority support</span>
            </div>
          </div>

          <div class="text-center">
            <button 
              disabled
              class="w-full px-8 py-4 bg-purple-500/50 text-white rounded-lg font-semibold cursor-not-allowed"
            >
              Coming Soon
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="max-w-4xl mx-auto mt-16">
      <h2 class="text-2xl md:text-3xl font-semibold text-white mb-8">Frequently Asked Questions</h2>
      <div class="grid gap-6">
        <div class="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
          <h3 class="text-xl font-semibold text-white mb-2">What's included in the free plan?</h3>
          <p class="text-gray-300">The free plan gives you access to our core features including paper analysis, AI summaries, and basic study tools. You can analyze up to 5 papers per month.</p>
        </div>
        <div class="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
          <h3 class="text-xl font-semibold text-white mb-2">When will the Premium plan be available?</h3>
          <p class="text-gray-300">We're working hard to launch our Premium plan soon. Sign up for the free plan to be notified when it becomes available.</p>
        </div>
        <div class="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
          <h3 class="text-xl font-semibold text-white mb-2">How do I get started?</h3>
          <p class="text-gray-300">Simply click the "Start Free with Google" button above and sign in with your Google account. No credit card required!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupPage',
  methods: {
    async handleGoogleSignIn() {
      try {
        // Implement Google Sign In logic here
        this.$router.push('/profile');
      } catch (error) {
        console.error('Google sign in error:', error);
      }
    }
  }
}
</script> 